import PageWithTitle from './PageWithTitle';
export default PageWithTitle;
